import { Observable } from 'rxjs';
import { LoginModel } from '@models/login.model';
import { LoginAdminModel } from '@models/login-admin.model';
import { AuthenticatedUserModel } from '@models/authenticated-user.model';
import {LoginTokenModel} from '@models/login-token.model';

/**
 * Responsible to perform user's authentication.
 * This interface defines functionality for managing authentication on ui,
 * especially authenticate user based on his credentials and remove/logout user when authenticated
 */
export abstract class AuthenticationService {

    /**
     * Perform authentication through backend call.
     * Authentication will be performed using implementation specific protocol.
     * @param loginData - {LoginModel}
     */
    abstract authenticate(loginData: LoginModel): Observable<AuthenticatedUserModel>;

    abstract authenticateWithToken(loginData: LoginTokenModel): Observable<AuthenticatedUserModel>;

    /**
     * Perform authentication of admin user on behalf of another user
     * @param loginData - {LoginAdminModel}
     */
    abstract authenticateAdmin(loginData: LoginAdminModel): Observable<AuthenticatedUserModel>;

    /**
     * Check if current user is authenticated
     */
    abstract isAuthenticated(): Observable<AuthenticatedUserModel>;

    /**
     * Handle successul response data returned from signin / signin admin
     * @param data - {AuthenticatedUserModel}
     * @param returnUrl - Optional URL to redirect to after successful login
     */
    abstract handleSignInSuccess(data: AuthenticatedUserModel, returnUrl?: string);

    /**
     * Handle error response data returned from signin / signin admin
     * @param error - {AuthenticatedUserModel}
     */
    abstract handleSignInError(error): string;

    /**
     * clear user authentication info
     */
    abstract logout();

    abstract showChatGPTConsent(): void;
}
